import * as utils from './LocalStorageHelpers';

const localStorageLastLocationKey = 'metronic-lastLocation';

function acceptLocation(lastLocation) {
  if (
    lastLocation &&
    lastLocation.pathname &&
    lastLocation.pathname !== '/' &&
    lastLocation.pathname.indexOf('auth') === -1 &&
    lastLocation.pathname !== '/logout'
  ) {
    return true;
  }

  return false;
}

export function saveLastLocation(lastLocation) {
  if (acceptLocation(lastLocation)) {
    utils.setStorage(
      localStorageLastLocationKey,
      JSON.stringify(lastLocation),
      120
    );
  }
}

export function forgotLastLocation() {
  utils.removeStorage(localStorageLastLocationKey);
}

export function getLastLocation() {
  const defaultLocation = { pathname: '/', title: 'Dashboard' };
  const localStorateLocations = utils.getStorage(localStorageLastLocationKey);
  if (!localStorateLocations) {
    return { pathname: '/', title: 'Dashboard' };
  }

  try {
    const result = JSON.parse(localStorateLocations);
    return result;
  } catch (error) {
    console.error(error);
    return defaultLocation;
  }
}

export function getCurrentUrl(location) {
  return location.pathname.split(/[?#]/)[0];
}

/**
 * Check if passed in urls is the current url to detect active menu
 * @param {string} location Current location
 * @param {string | string[]} urls Menu url
 * @returns boolean
 */
export function checkIsActive(location, urls) {
  const current = getCurrentUrl(location);
  if (!current || !urls) {
    return false;
  }

  // if (Array.isArray(urls)) {
  //   urls.forEach((url) => {
  //     // check it's the current url
  //     if (
  //       // and if so return true
  //       current.indexOf(urls) !== -1
  //     ) {
  //       return true;
  //     }
  //   })
  //   // for each item in the array
  //   for (const url of urls) {
  //     // check it's the current url
  //     if (
  //       current === url ||
  //       // and if so return true
  //       current.indexOf(urls) !== -1
  //     ) {
  //       return true;
  //     }
  //   }
  // } else {
  //   if (current === urls || current.indexOf(urls) > -1) {
  //     return true;
  //   }
  // }
  // return false;

  // convert string to array otherwise leave array alone
  return (Array.isArray(urls) ? urls : [urls]).find(
    (url) => current.indexOf(url) != -1 // if url is part of current then return true
  );
}
